import { css } from "styled-components";

export const consolePageButtonVariants = {
  primary: css`
    background-color: #605cff;
    color: #fafafa;
  `,
  secondary: css`
    background-color: ${({ theme }) =>
      theme?.console.secondaryButtonBackground};
    color: ${({ theme }) => theme.authModal.primaryText};
  `,
  confirm: css`
    background-color: #23a840;
    color: #ffffff;
  `,
  danger: css`
    background-color: #ec3434;
    color: #ffffff;
  `,
  transparent: css`
    color: ${({ theme }) => theme.authModal.primaryText};
  `,
  documentsError: css`
    background-color: #ffffff;
    color: #fd4848;
  `,
  documentsAlert: css`
    background-color: #ffeb39;
    color: #000000;
  `,
  info: css`
    background-color: #0073e5;
    color: #ffffff;
  `,
  light: css`
    background-color: #ffffff;
    color: #000000;
  `,

  import: css`
    background-color: #212121;
    color: #f2f2f2;
  `,

  neutral: css`
    border: 1px solid
      ${({ theme }) => (theme.mode === "dark" ? "#ffffff" : "#000000")}1f;
    background: ${({ theme }) =>
      theme.mode === "dark" ? "#ffffff" : "#000000"}0a;
    color: ${({ theme }) => (theme.mode === "dark" ? "#fafafa" : "#000000")};
  `,
};
